module.exports = {
    RECEIVE_ALL_AQUIFER: 'RECEIVE_ALL_AQUIFER',
    AQUIFER: 'AQUIFER',
    AQUIFERS: 'AQUIFERS',
    RESET_AQUIFER: 'RESET_AQUIFER',
}
